import React from "react";
import "../../styles/home/HeroSection.css";


const HeroSection = () => {
    return (
        <section className="hero-section">
            <div className="hero-trapezoid">
                <h1>Bytes & Brushes</h1>
                <p>Where design and code collide</p>
            </div>
        </section>
    );
};

export default HeroSection;